import { ChunkTransformationKey } from "@faire/localization/react/chunkTransformations";

export const ACCORDION_LABEL_ALLOWED_CHUNK_TRANSFORM_KEYS: ChunkTransformationKey[] =
  ["Medium"];

export const ACCORDION_LABEL_VARIANTS = ["subheading", "paragraph"] as const;
